module.exports = "/_next/static/images/login-cdb093e04d9c69403ea74b608740b6c9.png";